<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<!-- only doing this because I'm on a time crunch and this is breaking prod -->

<lib-reactive-form-group [bindTo]="viewModel.recurringDetails$ | push" [mergeKey]="mergeKey">
  <div class="mt-3 recurring-details-header">
    <div>
      <div class="bs-bold f18px">Recurring Details</div>
      <div class="bs-regular f14px">
        Select specific days of the week and times that the menu should appear on the display.
      </div>
    </div>
    <lib-reactive-form-switch
      #isRecurringSwitch
      [inputName]="'specificTimeOverride'"
      [selectedValue]="true"
      [notSelectedValue]="false"
      [bindOnSubmit]="true"
      [bindingProperty]="'isRecurring'"
      (valueChanged)="switchRecurringTimes($event)">
    </lib-reactive-form-switch>
  </div>
  <div #runsOnTimeInterval class="mt-4">
    <lib-reactive-form-row [gap]="'1rem'">
      <lib-reactive-form-time
        #StartTime
        [inputName]="'startTime'"
        [label]="'Start Time'"
        [placeholder]="'Choose a start time'"
        [inputStep]="'60'"
        [required]="isRecurringSwitch?.getMyValue()"
        [disabled]="!isRecurringSwitch?.getMyValue()"
        [bindOnSubmit]="true"
        [bindingProperty]="'timeDuration.startTime'">
      </lib-reactive-form-time>

      <lib-reactive-form-time
        #EndTime
        [inputName]="'endTime'"
        [label]="'End Time'"
        [placeholder]="'Choose an end time'"
        [inputStep]="'60'"
        [required]="isRecurringSwitch?.getMyValue()"
        [disabled]="!isRecurringSwitch?.getMyValue()"
        [bindOnSubmit]="true"
        [bindingProperty]="'timeDuration.endTime'">
      </lib-reactive-form-time>
    </lib-reactive-form-row>

    <lib-reactive-form-row>
      <lib-reactive-form-checkboxes
        #DaysOfWeekCheckboxes
        [customValueParser]="parseDaysOfWeek"
        [bindingProperty]="'timeDuration.days'"
        [requireMinimumSelection]="isRecurringSwitch?.getMyValue() ? 1 : 0"
        [label]="'Days'"
        [inputName]="'Days'"
        [checkAllText]="'Select all days'"
        [disabled]="!isRecurringSwitch?.getMyValue()"
        [bindOnSubmit]="true"
        [inlineOptions]="true">
        <lib-reactive-form-checkbox
          [inputName]="'sun'"
          [selectedValue]="Types.Weekday.Sunday"
          [notSelectedValue]="null"
          [disabled]="!isRecurringSwitch?.getMyValue()">
          Sunday
        </lib-reactive-form-checkbox>

        <lib-reactive-form-checkbox
          [inputName]="'mon'"
          [selectedValue]="Types.Weekday.Monday"
          [notSelectedValue]="null"
          [disabled]="!isRecurringSwitch?.getMyValue()">
          Monday
        </lib-reactive-form-checkbox>

        <lib-reactive-form-checkbox
          [inputName]="'tues'"
          [selectedValue]="Types.Weekday.Tuesday"
          [notSelectedValue]="null"
          [disabled]="!isRecurringSwitch?.getMyValue()">
          Tuesday
        </lib-reactive-form-checkbox>

        <lib-reactive-form-checkbox
          [inputName]="'wed'"
          [selectedValue]="Types.Weekday.Wednesday"
          [notSelectedValue]="null"
          [disabled]="!isRecurringSwitch?.getMyValue()">
          Wednesday
        </lib-reactive-form-checkbox>

        <lib-reactive-form-checkbox
          [inputName]="'thurs'"
          [selectedValue]="Types.Weekday.Thursday"
          [notSelectedValue]="null"
          [disabled]="!isRecurringSwitch?.getMyValue()">
          Thursday
        </lib-reactive-form-checkbox>

        <lib-reactive-form-checkbox
          [inputName]="'fri'"
          [selectedValue]="Types.Weekday.Friday"
          [notSelectedValue]="null"
          [disabled]="!isRecurringSwitch?.getMyValue()">
          Friday
        </lib-reactive-form-checkbox>

        <lib-reactive-form-checkbox
          [inputName]="'sat'"
          [selectedValue]="Types.Weekday.Saturday"
          [notSelectedValue]="null"
          [disabled]="!isRecurringSwitch?.getMyValue()">
          Saturday
        </lib-reactive-form-checkbox>
      </lib-reactive-form-checkboxes>
    </lib-reactive-form-row>
  </div>
</lib-reactive-form-group>
